import {Nullish} from 'shared/web';

import {LightboxAction} from './LightboxAction';

export interface LightboxVideo {
  id: string;
  videoId: string;
  originUrl: string | null;
  coverImageUrl: string | null;
  variants: {type: string; url: string}[] | null;
  actions?: LightboxAction[] | Nullish;
}
